import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCart } from '@/context/CartContext';
import { toast } from 'sonner';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  const handleAddToCart = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    await addToCart(product.id);
    toast.success(`${product.name} added to cart!`);
  };

  return (
    <Link to={`/product/${product.id}`} data-testid={`product-card-${product.id}`}>
      <div className="product-card bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden h-full flex flex-col">
        <div className="aspect-square overflow-hidden bg-gray-50">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
            data-testid="product-image"
          />
        </div>
        <div className="p-4 flex flex-col flex-grow">
          <h3 className="font-heading font-medium text-lg mb-2 line-clamp-2" data-testid="product-name">{product.name}</h3>
          <p className="text-sm text-gray-600 mb-3 line-clamp-2 flex-grow" data-testid="product-description">{product.description}</p>
          <div className="flex items-center justify-between mt-auto">
            <span className="text-2xl font-semibold text-medical-primary" data-testid="product-price">${product.price.toFixed(2)}</span>
            <Button
              onClick={handleAddToCart}
              className="bg-medical-primary hover:bg-medical-primary/90"
              size="sm"
              data-testid="add-to-cart-button"
            >
              <ShoppingCart className="w-4 h-4 mr-1" />
              Add
            </Button>
          </div>
          {product.stock < 10 && product.stock > 0 && (
            <p className="text-xs text-orange-600 mt-2">Only {product.stock} left in stock!</p>
          )}
          {product.stock === 0 && (
            <p className="text-xs text-red-600 mt-2">Out of stock</p>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;